import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

export const FAQPage = () => {
  return (
    <div className="landing-page" data-testid="faq-page">
      <SiteHeader />

      <section className="page-content-section">
        <div className="container page-container-inner" style={{ maxWidth: '900px' }}>
          <h1 className="page-main-title" data-testid="faq-title">Frequently Asked Questions</h1>

          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            <AccordionItem value="item-1">
              <AccordionTrigger>What is BuckTime!?</AccordionTrigger>
              <AccordionContent>
                BuckTime! is a screen-time choice app for families. You set what a day is worth. Your child starts the day holding the full amount — the apps you choose to monitor are the only thing that spends it. What they don't spend, they keep. Nothing is blocked, nothing is locked. The choice is theirs.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2">
              <AccordionTrigger>How does the earning system work?</AccordionTrigger>
              <AccordionContent>
                <strong>Say you set the day at $3 and give 1 hour free.</strong> Your child wakes up with $3 — it's already theirs. The first hour on monitored apps costs nothing. After that, every minute chips away at the $3. If they stop at 2 hours, they might keep $1.50. If they stay off completely after the free hour, they keep all $3. At the end of the day, you pay them whatever's left — cash, e-Transfer, however your family does it.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3">
              <AccordionTrigger>Does BuckTime! block apps on my child's phone?</AccordionTrigger>
              <AccordionContent>
                No. BuckTime! is a choice tool, not a blocker. Your child can always open a monitored app — doing so simply spends their day's money. We never block another app from opening, never lock the device, and never take the phone away. A limit gets argued with. A choice gets made.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4">
              <AccordionTrigger>What are the Three Jars?</AccordionTrigger>
              <AccordionContent>
                <strong>Spend, Save, Give.</strong> What your child keeps is split across three jars, so the money teaches something on the way out. You choose the split. On the Family plan, you can match what they save — money you add to their Save jar to reward the habit.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5">
              <AccordionTrigger>What is Buck and the Buck Shop?</AccordionTrigger>
              <AccordionContent>
                Buck is your child's in-app mascot. Kids earn coins for good habits — a clean day, a streak, a savings goal reached, a lesson finished. Coins buy hats, shades, shirts, boots and flags in the Buck Shop. The common collection is free on every plan; the Family plan unlocks rare, epic and legendary pieces.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6">
              <AccordionTrigger>What is Money School?</AccordionTrigger>
              <AccordionContent>
                Money School, Word Bank and Smart$ turn what your child is doing into what they understand — short lessons, real vocabulary, and medallions for finishing them. Included free on every plan.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7">
              <AccordionTrigger>How do kids get paid?</AccordionTrigger>
              <AccordionContent>
                You pay your child — BuckTime! just keeps the count. What your child keeps is recorded in the ledger; you settle up in cash, by e-Transfer from your own bank, or however you already do it. Spend-jar payouts have a $20 minimum. Save-jar cash-outs have no minimum. No bank linking, no fees, no money moves through BuckTime!.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8">
              <AccordionTrigger>How much does it cost?</AccordionTrigger>
              <AccordionContent>
                <strong>Basic is free</strong> — one child, one device. Full monitoring, daily earning, cash payouts, Three Jars, Money School, medallions, and the Buck Shop's common collection.<br /><br />
                <strong>Family is CA$6.99/month, or CA$59.99/year</strong> (save ~28%) — everything in Basic, plus unlimited children and devices, a second parent, fitness rewards, the full Buck Shop, jar matching, Save-jar payouts, and advanced insights with a weekly digest.<br /><br />
                <em>Subscriptions renew until cancelled. Cancel any time in Google Play or the App Store.</em>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-9">
              <AccordionTrigger>Can I customize which apps are monitored?</AccordionTrigger>
              <AccordionContent>
                Yes. You have full control over which apps count as monitored. You can select specific apps like TikTok, YouTube, or gaming apps — whatever makes sense for your family. You can change the list any time.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-10">
              <AccordionTrigger>What about fitness and getting active?</AccordionTrigger>
              <AccordionContent>
                On the Family plan, steps and active minutes earn on their own — so screen-free time becomes real time outside, not just time away from a screen.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-11">
              <AccordionTrigger>What devices does BuckTime! work on?</AccordionTrigger>
              <AccordionContent>
                BuckTime! is available on Android via Google Play and on iPhone and iPad via the App Store.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-12">
              <AccordionTrigger>Is this safe? What about privacy?</AccordionTrigger>
              <AccordionContent>
                BuckTime! is built for families and complies with COPPA, GDPR and PIPEDA. We never sell your data and never share it with advertisers. Children's profiles are created and controlled only by the parent, and you can delete your account and all of its data at any time from inside the app.
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <Card className="feature-card" style={{ marginTop: '3rem' }} data-testid="faq-contact-card">
            <CardContent className="feature-content">
              <h3 className="feature-title">Still have questions?</h3>
              <p className="feature-description">
                Reach out to us at{' '}
                <a href="mailto:support@bucktime.ca">support@bucktime.ca</a>
                {' '}or send feedback to{' '}
                <a href="mailto:feedback@bucktime.ca">feedback@bucktime.ca</a>
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default FAQPage;
